import { motion, AnimatePresence } from "framer-motion";
import { X, Download, ExternalLink } from "lucide-react";
import { resolveUrl } from "../lib/api";

export const PdfViewer = ({ open, url, title, onClose }) => {
  const src = resolveUrl(url);
  return (
    <AnimatePresence>
      {open && (
        <motion.div
          data-testid="pdf-viewer-overlay"
          className="fixed inset-0 z-[1000] flex flex-col bg-black/70 backdrop-blur-md"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.3 }}
        >
          <div className="flex items-center justify-between gap-4 border-b border-white/10 px-5 py-4 sm:px-8">
            <div className="min-w-0">
              <p className="font-mono text-[10px] uppercase tracking-[0.25em] text-white/50">
                Document Viewer
              </p>
              <h3 className="truncate font-display text-lg font-bold text-white sm:text-xl">
                {title}
              </h3>
            </div>
            <div className="flex shrink-0 items-center gap-2">
              <a
                data-testid="pdf-viewer-download"
                href={src}
                download
                target="_blank"
                rel="noreferrer"
                className="flex items-center gap-2 rounded-sm border border-white/20 px-4 py-2 font-mono text-xs uppercase tracking-widest text-white transition-colors hover:bg-white hover:text-black"
              >
                <Download size={14} /> <span className="hidden sm:inline">Download</span>
              </a>
              <a
                href={src}
                target="_blank"
                rel="noreferrer"
                className="flex items-center gap-2 rounded-sm border border-white/20 px-4 py-2 font-mono text-xs uppercase tracking-widest text-white transition-colors hover:bg-white hover:text-black"
              >
                <ExternalLink size={14} />
              </a>
              <button
                data-testid="pdf-viewer-close"
                onClick={onClose}
                className="flex items-center gap-2 rounded-sm bg-white px-4 py-2 font-mono text-xs uppercase tracking-widest text-black transition-colors hover:bg-white/80"
              >
                <X size={14} /> <span className="hidden sm:inline">Close</span>
              </button>
            </div>
          </div>
          <div className="flex-1 overflow-hidden p-2 sm:p-6">
            <iframe
              data-testid="pdf-viewer-iframe"
              title={title}
              src={src}
              className="h-full w-full rounded-sm bg-white"
            />
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};
